import React from 'react';

type IconProps = {
  size?: number; // Size of the icon
  className?: string; // Additional custom classes
};

const BeautyAndCareIcon: React.FC<IconProps> = ({ size = 22, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.253 11.002C19.253 15.5602 15.5578 19.2554 10.9995 19.2554C6.44128 19.2554 2.74609 15.5602 2.74609 11.002C2.74609 6.44373 6.44128 2.74854 10.9995 2.74854"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8143 2.19064C16.9352 1.96926 17.1673 1.83154 17.4196 1.83154C17.6718 1.83154 17.9039 1.96926 18.0248 2.19064L18.5595 3.1673C18.6229 3.28347 18.7184 3.37897 18.8346 3.44241L19.8112 3.97613C20.0331 4.09688 20.1712 4.32926 20.1712 4.58184C20.1712 4.83443 20.0331 5.0668 19.8112 5.18755L18.8346 5.72219C18.7181 5.78525 18.6225 5.88085 18.5595 5.99731L18.0248 6.97305C17.9039 7.19443 17.6718 7.33214 17.4196 7.33214C17.1673 7.33214 16.9352 7.19443 16.8143 6.97305L16.2797 5.99639C16.2166 5.87993 16.121 5.78434 16.0046 5.72128L15.0279 5.18755C14.8061 5.0668 14.668 4.83443 14.668 4.58184C14.668 4.32926 14.8061 4.09688 15.0279 3.97613L16.0046 3.44241C16.1207 3.37897 16.2162 3.28347 16.2797 3.1673L16.8143 2.19064Z"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M8.24856 8.55225V9.46929"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7515 8.55225V9.46929"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9731 13.439C12.3309 15.0798 9.66994 15.0798 8.02783 13.439"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BeautyAndCareIcon;
